import { useState } from "react";

const LISTING_TYPES = ["Maquinaria", "Terras", "Ambos"];

export default function GuestsPanel({ value, onChange, onClose }) {
  const listingType = value?.listingType ?? "Ambos";

  function setListingType(type) {
    onChange({ ...value, listingType: type });
  }

  return (
    <div className="absolute top-full mt-2 bg-white rounded-2xl shadow-card-hover border border-border p-4 z-50 w-64 animate-fade-in">
      {/* Listing type toggle */}
      <div className="mb-4">
        <p className="text-sm font-semibold text-dark mb-3">
          Tipo de anuncio
        </p>
        <div className="flex flex-col gap-2">
          {LISTING_TYPES.map((type) => (
            <button
              key={type}
              type="button"
              onClick={() => setListingType(type)}
              className={[
                "text-sm px-4 py-2 rounded-xl border transition-colors text-left",
                listingType === type
                  ? "border-dark bg-dark text-white"
                  : "border-border text-dark hover:border-dark bg-white",
              ].join(" ")}
            >
              {type}
            </button>
          ))}
        </div>
      </div>

      {/* Apply button */}
      <button
        type="button"
        onClick={onClose}
        className="btn-primary w-full bg-rauxa text-white rounded-xl px-4 py-2 text-sm font-semibold hover:bg-rauxa/90 transition-colors"
      >
        Aplicar
      </button>
    </div>
  );
}
